import { useState, useRef } from "react";
import SectionContainer from "../../container/SectionContainer";
import {
	CoorporateScheme,
	Constant,
} from "client-v2";
import { ColorV2, InputPhone } from "@adoptaunabuelo/react-components";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import {
	ConfirmationResult,
	getAuth,
	RecaptchaVerifier,
	signInWithPhoneNumber,
} from "firebase/auth";

const Login = (props: LoginProps) => {
	const translation = useSelector(
		(state: State) => state.location.translation
	);
	const appLocation = useSelector((state: State) => state.location.location);
	const appVerifierRef = useRef<RecaptchaVerifier | null>(null);
	const colors =
		props.corporate && props.corporate.color
			? {
					buttonBackground: props.corporate.color.main,
					buttonColor: props.corporate.color.third,
			  }
			: {
					buttonBackground: ColorV2.surface.primary,
					buttonColor: "white",
			  };
	const [loading, setLoading] = useState(false);
	const [phoneData, setPhoneData] = useState<
		| {
				value?: string;
				country: string;
				isValid?: boolean;
		  }
		| undefined
	>({
		country:
			appLocation && appLocation.country_code
				? appLocation.country_code
				: "ES",
	});
	const [phoneError, setPhoneError] = useState<string | undefined>(undefined);
	const phoneCountries = Constant.countries();

	const onNextClick = async () => {
		const result = getData();
		if (result && result.phone) {
			setLoading(true);
			// Auth.sendCodeTwilio({
			// 	phone: result.phone,
			// 	coorporateId: props.corporate?.objectId,
			// })
			// 	.then((result) => {
			// 		localStorage.setItem(
			// 			"temp-login",
			// 			JSON.stringify({
			// 				date: new Date(),
			// 				user: result.data.User,
			// 			})
			// 		);
			// 		setLoading(false);
			// 		props.onFinish({
			// 			data: result.data.User,
			// 		});
			// 	})
			// 	.catch((error: ErrorScheme) => {
			// 		setLoading(false);
			// 		props.onFinish({
			// 			error: error.message,
			// 		});
			// 	});
			const auth = getAuth();

			// Crear el verificador solo si no existe
			if (!appVerifierRef.current) {
				appVerifierRef.current = new RecaptchaVerifier(
					auth,
					"recaptcha-div",
					{
						size: "invisible",
						callback: function (response: any) {
							//console.log(response);
						},
					}
				);
			}

			signInWithPhoneNumber(auth, result.phone, appVerifierRef.current)
				.then((confirmationResult) => {
					setLoading(false);
					props.onFinish({
						data: {
							confirmationResult: confirmationResult,
							phone: result.phone,
						},
					});
				})
				.catch((error) => {
					setLoading(false);
					// Limpiar el verificador en caso de error para que se pueda reintentar
					appVerifierRef.current?.clear();
					appVerifierRef.current = null;
					props.onFinish({
						error: error.message,
					});
				});
		}
	};

	const getData = () => {
		if (phoneData?.country && phoneData?.value) {
			if (phoneData.isValid) {
				setPhoneError(undefined);
				return {
					phone: phoneData.country + phoneData.value,
				};
			} else {
				setPhoneError(translation.component_input_phone_error_01);
				return undefined;
			}
		} else {
			setPhoneError(translation.component_input_phone_error_02);
			return undefined;
		}
	};

	const onInputChange = (data: any) => {
		setPhoneData(data);
		setPhoneError(undefined);
	};

	const onKeyDown = (e: any) => {
		if (e.key === "Enter") {
			onNextClick();
		}
	};

	return (
		<SectionContainer
			title={"¡Empezamos con tu teléfono!"}
			subtitle={
				"Ten el móvil cerca, te vamos a enviar un SMS con un código de verificación."
			}
			buttonProps={{
				style: {
					backgroundColor: colors.buttonBackground,
					color: colors.buttonColor,
				},
				backgroundColor: "white",
				children: translation.component_button_next,
				loading: loading,
				onClick: onNextClick,
			}}
		>
			<InputPhone
				id={"input-phone"}
				autoComplete={"tel"}
				name={"telephone"}
				placeholder={translation.component_input_phone_placeholder}
				error={phoneError}
				country={phoneData?.country}
				countryOptions={phoneCountries}
				design={"secondary"}
				onKeyDown={onKeyDown}
				onPhoneChange={onInputChange}
			/>
			<div id="recaptcha-div"></div>
		</SectionContainer>
	);
};
export default Login;
export interface LoginProps {
	corporate?: CoorporateScheme;
	onFinish: (result: {
		data?: { confirmationResult: ConfirmationResult; phone: string };
		// data?: UserScheme;
		error?: string;
	}) => void;
}
